import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The static manifest starts at "/", so "Add to home screen"/"Create shortcut" on any page reopened the
// home page (and, for staff, the login redirect). Point the manifest at the page being viewed instead.
const RouteManifest = () => {
  const location = useLocation();

  useEffect(() => {
    // The scan page sets its own manifest (scanner name, scope).
    if (/\/admin\/events\/[^/]+\/scan$/.test(location.pathname)) return undefined;
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return undefined;
    const { origin } = window.location;
    const url = `${origin}${location.pathname}${location.search}`;
    const title = (document.title || 'EventEase').split(' - ')[0];
    const manifest = {
      id: location.pathname,
      name: title,
      short_name: title.length > 12 ? title.slice(0, 12) : title,
      start_url: url,
      scope: `${origin}/`,
      display: 'standalone',
      theme_color: '#000000',
      background_color: '#ffffff',
      icons: [
        { src: `${origin}/fevicon.png`, sizes: '64x64', type: 'image/png' },
        { src: `${origin}/icon-192.png`, sizes: '192x192', type: 'image/png' },
        { src: `${origin}/icon-512.png`, sizes: '512x512', type: 'image/png' },
      ],
    };
    const previous = link.getAttribute('href');
    const blobUrl = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' }));
    link.setAttribute('href', blobUrl);
    return () => {
      if (link.getAttribute('href') === blobUrl) link.setAttribute('href', previous);
      URL.revokeObjectURL(blobUrl);
    };
  }, [location.pathname, location.search]);

  return null;
};

export default RouteManifest;
